module.exports = __webpack_public_path__ + "static/media/at-mock-1.b05aaa1d.png";